// Todo: esto es mejor que se llame types, para que no colisione con el nombre de la 12
export const types = {
  SET_ACTIVE_SLIDE: 'UI/SET_ACTIVE_SLIDE',
};
export const SLIDER_ID = {
  Prueba: 'pruebaSlider',
};
export const actions = {
  setActiveSlide: ({ sliderId, slideIndex }) => ({
    type: types.SET_ACTIVE_SLIDE,
    data: {
      sliderId,
      slideIndex,
    },
  }),
};

export const initialState = {
  sliders: {
    pruebaSlider: 0,
  },
};

function uiReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.SET_ACTIVE_SLIDE: {
      const { sliderId, slideIndex } = action.data;
      return {
        ...state,
        sliders: {
          ...state.sliders,
          [sliderId]: slideIndex,
        },
      };
    }
    default:
      return state;
  }
}

export default uiReducer;
